import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { formatDate, isPlatformBrowser } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';
import { AnimationOptions } from 'ngx-lottie';
import { DeviceDetectorService } from 'ngx-device-detector';
import { LeadFormComponent } from '../../shared/lead-form/lead-form.component';
import { MatDialog } from '@angular/material/dialog';
import { APIService } from 'src/app/services/api.service';
import {
  animate,
  group,
  query,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

interface DetailItem {
  name: string;
  image: string;
}

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss'],
  standalone: false,
  animations: [
    // trigger('fadeInOut', [
    //   state(
    //     'void',
    //     style({
    //       opacity: 0,
    //     })
    //   ),
    //   state(
    //     '*',
    //     style({
    //       opacity: 1,
    //     })
    //   ),
    //   transition('void <=> *', animate('300ms ease-in-out')),
    //   transition('* <=> *', [
    //     style({ opacity: 0 }),
    //     animate('300ms ease-in-out', style({ opacity: 1 })),
    //   ]),
    // ]),
    // trigger('expandCollapse', [
    //   state(
    //     'collapsed',
    //     style({
    //       height: '0px',
    //       overflow: 'hidden',
    //       opacity: 0,
    //     })
    //   ),
    //   state(
    //     'expanded',
    //     style({
    //       height: '*',
    //       opacity: 1,
    //     })
    //   ),
    //   transition('collapsed <=> expanded', animate('200ms ease-in-out')),
    // ]),
    trigger('fadeInOut', [
      state(
        'void',
        style({
          opacity: 0,
        })
      ),
      state(
        '*',
        style({
          opacity: 1,
        })
      ),

      transition('* => *', [
        group([
          query(
            ':leave',
            [
              style({ opacity: 1, transform: 'translateX(0)' }),
              animate(
                '300ms ease-out',
                style({
                  opacity: 0,
                  transform: 'translateX(100%)',
                })
              ),
            ],
            { optional: true }
          ),
          query(
            ':enter',
            [
              style({
                opacity: 0,
                transform: 'translateY(100%)',
              }),
              animate(
                '400ms ease-out',
                style({
                  opacity: 1,
                  transform: 'translateY(0)',
                })
              ),
            ],
            { optional: true }
          ),
        ]),
      ]),
      transition('void => *', [
        style({
          opacity: 0,
          transform: 'translateY(50px)',
        }),
        animate('400ms ease-out'),
      ]),
    ]),
    trigger('expandCollapse', [
      state(
        'collapsed',
        style({
          height: '0px',
          overflow: 'hidden',
          opacity: 0,
        })
      ),
      state(
        'expanded',
        style({
          height: '*',
          opacity: 1,
        })
      ),
      transition('collapsed <=> expanded', animate('200ms ease-in-out')),
    ]),
  ],
})
export class ProductComponent implements OnInit {
  financeTab: boolean = true;
  communicationTab: boolean = false;
  peopletab: boolean = false;
  classroomTab: boolean = false;
  frstCard = true;
  secondCard = false;
  thirdCard = false;

  logoUrl: any;
  slideInt: any;
  slideInterval = 100;
  infiniteSlide = true;
  selectedIndex = 0;

  imageSize = {
    width: '80px',
    height: '80px',
    space: 12,
  };
  imageSizeMobile = {
    width: '58px',
    height: '58px',
    space: 6,
  };

  autoSlide = { interval: 1, stopOnHover: true };

  userCards: any = [
    {
      imgsrc:
        'https://res.cloudinary.com/inforida-in/image/upload/c_scale,h_105/v1524555310/user-male-icon.png',
      name: 'Mr. Jai Singh, Principal',
      school: 'Saraswati Shishu Mandir, Lakhimpur',
      description: `I was initially hesitant to take the software due to no technical knowledge, but within few days of using it, Inforida team has made me comfortable with the software and now I am so much dependent on it while managing my institution.`,
    },
    {
      imgsrc:
        'https://res.cloudinary.com/inforida-in/image/upload/c_scale,h_105/v1524555310/user-female-icon.png',
      name: 'Mrs. Shivani Awasthi, Principal',
      school: 'Sanik Sanjeevani Public School, Sitapur',
      description: `The most economical and user friendly School Management System, Our School Staff is using it from past three years and found it surprisingly easy to use. The interface for School Admin, Accountant, Teachers, parents and student is attractive and very easy to follow.`,
    },
    {
      imgsrc: 'https://my.inforida.com/assets/images/sakal.png',
      name: 'Mr. Sanjay Singh, Owner',
      school: 'Sakalnarayan Memorial Public School, Raebareli',
      description: `Our school was loosing ₹10-15 Lacks every acedemic session.
      Thanks to Inforida now I can manage, view and download all financial reports in one click from anywhere. We are using Inforida from last 4 years and never had any problems.`,
    },
    {
      imgsrc: 'https://my.inforida.com/assets/images/mkd.png',
      name: 'Mr. Priyansh Dixit, Owner',
      school: 'Saraswati Shishu Mandir, Lakhimpur',
      description: `The customer support team is super fast and attempts to solve every query/issue. Very easy to use, great school management system with an innovative approach for every problem faced in school administration.
      `,
    },
  ];

  productCards: any = [
    {
      imgsrc: [
        {
          name: 'Fee Collection',
          url: '../../../assets/images/fee collection.svg',
        },
        {
          name: 'Income & Expense',
          url: '../../../assets/images/expense.svg',
        },
        {
          name: 'Payroll for your staff',
          url: '../../../assets/images/payroll.svg',
        },
      ],
      Label: 'Finance',
      logo: '../../assets/images/Group 7540.svg',
      color: '#DEF5E6',
      description: `Digitise and automate all finance
      operations and improve collection efficiency.`,
    },
    {
      imgsrc: [
        {
          name: 'School Calender',
          url: '../../assets/images/Group 7722.svg',
        },
        {
          name: 'Notifications',
          url: '../../assets/images/Group 7724.svg',
        },
        {
          name: 'Activity Feed',
          url: '../../assets/images/Group 7726.svg',
        },
      ],
      Label: 'Communication',
      logo: '../../assets/images/Group 7131.svg',
      color: '#DEEBFF',
      description: `Implement communication channel across
    eco-system`,
    },
    {
      imgsrc: [
        {
          name: 'Attendance',
          url: '../../assets/images/Group 7638.svg',
        },
        {
          name: 'People & Performance',
          url: '../../assets/images/Group 7638.svg',
        },
        {
          name: 'Roles and Permissions',
          url: '../../assets/images/Group 7677.svg',
        },
      ],
      Label: 'People',
      logo: '../../assets/images/Group 7130.svg',
      color: '#FAF2D9',
      description: `All you need to measure and improve
        people performance`,
    },
    {
      imgsrc: [
        {
          name: 'Dynamic Timetable',
          url: '../../assets/images/Group 7682.svg',
        },
        {
          name: 'Class Performance',
          url: '../../assets/images/Group 7681.svg',
        },
        {
          name: 'Classroom Vault',
          url: '../../assets/images/Group 1122.png',
        },
      ],
      Label: 'Classroom',
      logo: '../../assets/images/Group 7160.svg',
      color: '#E7D7D2',
      description: `All you need to measure and improve
      people performance`,
    },
  ];

  cards = [
    {
      name: 'People',
      details: [
        {
          name: 'Role Based Access',
          image:
            'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/pillar-main-image1.png',
        },
        {
          name: 'Attendance System',
          image:
            'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/attendance-system.svg',
        },
      ],
    },
    {
      name: 'Finance',
      details: [
        {
          name: 'Fee Collection',
          image:
            'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/pillar-main-image3.png',
        },
        {
          name: 'Income & Expense',
          image:
            'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/income-expense.svg',
        },
      ],
    },
    {
      name: 'Classroom',
      details: [
        {
          name: 'Dynamic Timetable',
          image:
            'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/time-table.svg',
        },
        {
          name: 'Class Performance',
          image:
            'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/class-performance.svg',
        },
        {
          name: 'Classroom Vault',
          image:
            'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/classroom-vault.svg',
        },
      ],
    },
    {
      name: 'Communication',
      details: [
        {
          name: 'School Calender',
          image:
            'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-calendar.svg',
        },
        {
          name: 'Notifications',
          image:
            'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/notifications.svg',
        },
        {
          name: 'Activity Feed',
          image:
            'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/activity-feed.svg',
        },
      ],
    },
  ];

  expandedSection: string = '';
  selectedDetail: DetailItem | null = null;
  animationState: string = 'initial';
  baseUrl = 'https://cal.com/inforida-demo/30min';
  updatedLink: string = '';

  constructor(
    private dialog: MatDialog,
    private title: Title,
    private meta: Meta,
    private deviceDetectorService: DeviceDetectorService,
    public apiService: APIService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit(): void {
    this.title.setTitle(
      "Discover Our Product Suite | Elevate Your School's Performance With Inforida "
    );
    this.meta.addTags([
      { name: 'title', content: 'Discover Our Product Suite' },
      {
        name: 'description',
        content: `${formatDate(
          Date.now(),
          'EEE, dd MMMM YYYY',
          'en-US'
        )} : Request a demo today to see how Inforida can revolutionize your school's digital experience. Our customizable products offer a seamless education solution for owners, principals,  teachers, registrars, accountants, HR, students, and parents alike. Join the smart schools revolution with Inforida. Our cutting-edge products and services are designed for your success.`,
      },
      {
        name: 'keywords',
        content:
          'smart school, school erp, education technology, school performance, schools of future, best school erp, school admission software, fees collection software, school fees, school attendance, school tools, school management, Edtech solutions, Classroom technology, Digital learning tools, School management software, Student information systems, Learning management systems, Educational apps, Academic technology, Online learning platforms, E- learning solutions, Education technology, Classroom management solutions, Customizable digital tools, School administration software, Teacher productivity tools, Parent communication platform, Student performance analytics',
      },
    ]);
    this.getLogo();
    this.updateLink();
    if (isPlatformBrowser(this.platformId)) {
      this.slideInt = setInterval(() => {
        this.nextslide();
      }, this.slideInterval);
    }
    this.expandedSection = 'People';
    if (this.cards.length > 0 && this.cards[0].details.length > 0) {
      this.selectedDetail = this.cards[0].details[0];
    }
  }
  lottieOptions: AnimationOptions = {
    path: 'https://inforida.ams3.cdn.digitaloceanspaces.com/lottie/product.json',
  };

  onTabclick(tabid: any) {
    if (tabid == 1) {
      this.financeTab = true;
      this.communicationTab = false;
      this.peopletab = false;
      this.classroomTab = false;
    } else if (tabid == 2) {
      this.financeTab = false;
      this.communicationTab = true;
      this.peopletab = false;
      this.classroomTab = false;
    } else if (tabid == 3) {
      this.financeTab = false;
      this.communicationTab = false;
      this.peopletab = true;
      this.classroomTab = false;
    } else {
      this.financeTab = false;
      this.communicationTab = false;
      this.peopletab = false;
      this.classroomTab = true;
    }
    this.frstCard = true;
    this.secondCard = false;
    this.thirdCard = false;
  }

  ngOnDestroy(): void {
    if (this.slideInt) {
      clearInterval(this.slideInt);
    }
  }

  getLogo() {
    this.apiService.getSchoolLogo().subscribe((res: any) => {
      this.logoUrl = res;
    });
    if (this.logoUrl.length) {
      let thumbSize = 'h_280,w_360';
      let finalSize = 'h_800';

      this.logoUrl = this.logoUrl.map((img: any) => {
        img.thumbImage = this.transformImageSize(img.url, thumbSize);
        img.image = this.transformImageSize(img.url, finalSize);
        img.alt = '';
        img.title = '';
        return img;
      });
    }
  }

  transformImageSize(url, size) {
    if (url && url.length && url.includes('cloudinary')) {
      const urlSplit = url.split('/upload/');
      return `${urlSplit[0]}/upload/${size}/${urlSplit[1]}`;
    }
    return url;
  }

  nextslide() {
    if (this.selectedIndex === this.userCards.length - 1) {
      this.selectedIndex = 0;
    } else {
      this.selectedIndex = this.selectedIndex + 1;
    }
  }

  getImgSize() {
    if (this.isMobile()) {
      return this.imageSizeMobile;
    } else {
      return this.imageSize;
    }
  }

  isMobile(): boolean {
    // return this.deviceDetectorService.isMobile();
    return (
      window.matchMedia(`(min-width: 200px)`).matches &&
      window.matchMedia(`(max-width: 700px)`).matches
    );
  }

  toggleSection(sectionName: string): void {
    if (this.expandedSection === sectionName) {
      return;
    }

    this.expandedSection = sectionName;

    const section = this.cards.find((card) => card.name === sectionName);
    if (section && section.details.length > 0) {
      this.changeDetail(section.details[0]);
    }
  }

  changeDetail(detail: DetailItem): void {
    // if (this.selectedDetail?.name === detail.name) return;

    // this.animationState =
    //   this.animationState === 'initial' ? 'final' : 'initial';
    // setTimeout(() => {
    //   this.selectedDetail = detail;
    // }, 1000);
    if (this.selectedDetail?.name === detail.name) return;

    const previousDetail = this.selectedDetail;

    this.selectedDetail = detail;
  }

  isSectionActive(sectionName: string): boolean {
    return this.expandedSection === sectionName;
  }

  isDetailActive(detailName: string): boolean {
    return this.selectedDetail?.name === detailName;
  }

  getSectionState(sectionName: string): string {
    return this.isSectionActive(sectionName) ? 'expanded' : 'collapsed';
  }

  openDialog() {
    this.dialog.open(LeadFormComponent, {
      width: this.isMobile() ? '90vw' : '800px',
      maxWidth: this.isMobile() ? '90vw' : '800px',
      height: this.isMobile() ? '90vh' : '600px',
      maxHeight: this.isMobile() ? '90vh' : '600px',
      restoreFocus: false,
      hasBackdrop: true,
      closeOnNavigation: false,
      disableClose: true,
    });
  }

  onCardClick(cardId: any) {
    if (cardId == 1) {
      this.frstCard = true;
      this.secondCard = false;
      this.thirdCard = false;
    } else if (cardId == 2) {
      this.frstCard = false;
      this.secondCard = true;
      this.thirdCard = false;
    } else {
      this.frstCard = false;
      this.secondCard = false;
      this.thirdCard = true;
    }
  }

  goToPage() {
    const url =
      'https://cal.com/inforida-demo/30min?month=2025-01&date=2025-01-18';
    if (isPlatformBrowser(this.platformId)) {
      window.open(this.updatedLink, '_blank');
    }
  }

  updateLink() {
    const today = new Date();
    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    const date = today.getDate().toString().padStart(2, '0');
    this.updatedLink = `${this.baseUrl}?month=${year}-${month}&date=${year}-${month}-${date}`;
  }
}
